import axios from "axios";
import { getAPIToken } from "./authservice";

// ✅ instance is now passed in from components
const getItemdata = async (productID, metric, locale, subLocale, instance) => {
    try {
        console.log(productID, metric, locale, subLocale);

        const token = await getAPIToken(instance);
        const headers = {
            Authorization: `Bearer ${token}`,
        };

        const response = await axios.get(
            `${process.env.REACT_APP_DATA_API}api/Items/productItem?ItemNo=${productID}&Locale=${locale}&Metric=${metric}`,
            { headers }
        );

        if (response.status === 401) {
            return "something went wrong";
        }

        return response.data;

    } catch (error) {
        console.error(error);
        throw new Error("Something went wrong");
    }
};

// ✅ instance is now passed in from components
const getTechnicalData = async (productID, weighUnit, lengthUnit, instance) => {
    try {
        const token = await getAPIToken(instance);
        const headers = {
            Authorization: `Bearer ${token}`,
        };

        const response = await axios.get(
            `${process.env.REACT_APP_DATA_API}api/Items/TechnicalData?ItemNo=${productID}&mms_inches=${lengthUnit}&gs_lbs=${weighUnit}`,
            { headers }
        );

        if (response.status !== 200) {
            throw new Error("Something went wrong");
        }

        return response.data;

    } catch (error) {
        console.error(error);
        throw new Error("Something went wrong");
    }
};

// ✅ Updated to use new API
// → No more blob response
// → No more old ashx params
// → Returns base64 string directly
const getImage = async (productID, par, instance) => {
    try {
        const token = await getAPIToken(instance);
        const headers = {
            Authorization: `Bearer ${token}`,
        };

        // ✅ New params match our .NET API endpoint
        const imageUrl = `${process.env.REACT_APP_IMAGE_API}?imageName=${productID}&param=${par}`;

        const response = await axios.get(imageUrl, { headers });

        if (response.status !== 200) {
            throw new Error("Image not found");
        }

       // ✅ Handle both cases - direct string or wrapped in result
        const imageData = response.data?.result ?? response.data;
        return imageData;

    } catch (error) {
        console.error('Error fetching image:', error);
        return null;
    }
};

const brand_color = {
    "FGF": "#7ac141",
    "Stonefire": "Orange",
    "Ace": "Grey",
    "Simple Joys": "#5478d1",
    "Millcroft Baking": "#1F3B2C"
};

const getBrandColor = (brand) => {
    if (!brand) {
        return "Grey";
    }
    if (Object.keys(brand_color).includes(brand)) {
        return brand_color[brand];
    }
    const match = Object.keys(brand_color).find(
        (key) => key.toLowerCase() === brand.trim().toLowerCase()
    );
    return match ? brand_color[match] : "Grey";
};

const getDropdownOptions = () => {
    const options = [
        { value: 'chocolate', label: 'Chocolate' },
        { value: 'strawberry', label: 'Strawberry' },
        { value: 'vanilla', label: 'Vanilla' },
    ];
    return options;
};

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

const salesSheetTitles = {
    "en": {
        "Product Specifications": "Product Specifications",
        "Ingredients": "Ingredients",
        "Features & Benefits": "Features & Benefits",
        "Handling Instructions": "Handling Instructions"
    },
    "fr": {
        "Product Specifications": "Spécifications du produit",
        "Ingredients": "Ingrédients",
        "Features & Benefits": "Caractéristiques et avantages",
        "Handling Instructions": "Instructions de manipulation"
    }
};

const makeSalesSheetTitles = (titleName, locale, subLocale) => {
    if (locale === subLocale || subLocale === "none") {
        return salesSheetTitles[locale][titleName];
    }
    return salesSheetTitles[locale][titleName] + "/" + 
           salesSheetTitles[subLocale][titleName];
};

export { 
    getItemdata, 
    getImage, 
    getBrandColor, 
    getDropdownOptions, 
    sleep, 
    getTechnicalData, 
    makeSalesSheetTitles 
};